/* Added the following code for Istiyak using AI Agent. October 22, 2026. Code Start */
import React from 'react';

/**
 * Route config for Sourcing Performance.
 * Registered with the recruiter route list and opened from Home in the sidebar.
 */
const SourcingPerformanceConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/sourcing-performance',
			component: React.lazy(() => import('./SourcingPerformance'))
		}
	]
};

export default SourcingPerformanceConfig;
/* Code end. Istiyak using AI Agent. October 22, 2026 */
